import refs from '../helpers/refs'
import cart from '../helpers/cart-helper'

class CCartItems {
  constructor (el) {
    this.$root = el
    this.$refs = refs(el)

    this.init()
  }

  init () {
    if (!Array.isArray(this.$refs.remove)) {
      this.$refs.remove = [this.$refs.remove]
    }
    if (!Array.isArray(this.$refs.update)) {
      this.$refs.update = [this.$refs.update]
    }

    this.$refs.remove.forEach((node) => {
      if (node) {
        node.addEventListener('click', (e) => {
          this.remove(node)
        })
      }
    })

    this.$refs.update.forEach((node) => {
      if (node) {
        node.addEventListener('change', (e) => {
          this.update(node)
        })
      }
    })

    // On some browsers, hitting back restores an older cart state, force reload to avoid this.
    // Note: When hitting back button to go to back to the cart page, the double refresh is expected.
    // When back/forward is used to go to the /cart, ensuring the correct cart items takes precedent over the poor UX of a double refresh.
    const navigation = performance.getEntriesByType('navigation')[0]
    if (navigation.type === 'back_forward' && window.location.pathname === '/cart') {
      location.reload()
    }
  }

  remove (node) {
    return new Promise((resolve, reject) => {
      cart.getProduct(node.dataset.productHandle)
        .then((response) => {
          // console.log('Remove from cart data response:', response)
          return response
        })
        .then((data) => {
          // console.log('Remove from cart data resolve:', data)

          const newData = {
            remove: {
              products: []
            }
          }

          newData.remove.products.push({
            id: node.dataset.productSku,
            name: data.title,
            price: data.price / 100,
            brand: data.vendor,
            category: data.type,
            variant: data.title,
            quantity: node.dataset.productQty
          })

          // clear previous object
          window.dataLayer.push({ ecommerce: null })
          window.dataLayer.push({
            event: 'removeFromCart',
            ecommerce: newData
          })

          resolve()
        })
        .catch((err) => {
          console.error('Remove from cart error:', err)

          reject(err)
        })
    })
  }

  update (node) {
    console.log('cart.update', node.dataset.productId, node.value)
  }
}

// There wa a TODO to only apply this to the cart page, but also needed for cart drawer so leave on all pages
document.addEventListener('DOMContentLoaded', () => {
  document
    .querySelectorAll('.c-cart-items')
    .forEach(el => new CCartItems(el))
})

// Reset event listeners on cart update
document.addEventListener('cartItems:updated', () => {
  document
    .querySelectorAll('.c-cart-items')
    .forEach(el => new CCartItems(el))
})
